// Display and persisted values share the same country-aware formatting rules.
const phoneNormalization = require('./phoneNormalization');

export const formatPhoneNumber = phoneNormalization.formatPhoneNumber;
export const formatPhoneValueForRow = phoneNormalization.formatPhoneValueForRow;
export const formatPhoneInput = phoneNormalization.formatPhoneInput;
export const formatPhoneInputForRow = phoneNormalization.formatPhoneInputForRow;
export const isPhoneColumnLabel = phoneNormalization.isPhoneColumnLabel;
